import React from 'react';
import { Outlet, Link, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SafeIcon from '../common/SafeIcon';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();

  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  const navItems = [
    { path: '/admin', label: 'Overview', icon: 'Activity' },
    { path: '/admin/users', label: 'Users', icon: 'Users' },
    { path: '/admin/bunkmates', label: 'Bunkmates', icon: 'Heart' },
    { path: '/admin/content', label: 'Content', icon: 'Layout' },
    { path: '/admin/letters', label: 'Letters Queue', icon: 'Mail' },
    { path: '/admin/passes', label: 'Passes', icon: 'Award' },
    { path: '/admin/settings', label: 'Settings', icon: 'Settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row">
      <aside className="w-full md:w-64 bg-gwa-blue text-white flex flex-col">
        <div className="p-6">
          <h1 className="text-xl font-bold">GWA Admin</h1>
          <p className="text-sm opacity-80">Camp FaiBoWriMo</p>
        </div>
        
        <nav className="flex-1 px-4 space-y-1">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2 rounded-md transition-colors ${
                location.pathname === item.path ? 'bg-white/20 text-white' : 'text-gray-300 hover:bg-white/10'
              }`}
            >
              <SafeIcon name={item.icon} className="text-lg" />
              <span className="text-sm">{item.label}</span>
            </Link>
          ))}
        </nav>
        
        <div className="p-4 border-t border-white/10 mt-auto">
          <Link to="/dashboard" className="flex items-center gap-3 px-4 py-2 text-gray-300 hover:text-white">
            <SafeIcon name="ArrowLeft" /> Camper View
          </Link>
          <button onClick={logout} className="flex items-center gap-3 px-4 py-2 text-gray-300 hover:text-white w-full text-left mt-2">
            <SafeIcon name="LogOut" /> Logout
          </button>
        </div>
      </aside>
      
      <main className="flex-1 p-6 md:p-10 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}